function env(name: string): string | undefined {
  const value = process.env[name];
  return value && value.trim() !== "" ? value : undefined;
}

export const URLS = {
  privacyPolicy:
    env("REACT_APP_PRIVACY_POLICY_URL") ??
    "https://www.ostgotatrafiken.se/kontakt-och-hjalp/villkor-och-regler/villkor-nar-du-reser-med-oss/hantering-av-personuppgifter",

  IslandFerryServices:
    "/res-med-oss/bestallningstrafik/skargardstrafik/tidtabeller-for-skargardstrafik",
};

export const SPA_TARGETS = {
  stops: env("REACT_APP_STOPS_URL"),
  lines: env("REACT_APP_LINES_URL"),
  map: env("REACT_APP_MAP_URL"),
};

type SpaTargetKey = keyof typeof SPA_TARGETS;

export function buildSpaUrl(
  key: SpaTargetKey,
  params?: Record<string, string | number | undefined>
) {
  const baseUrl = SPA_TARGETS[key];

  if (!baseUrl) {
    throw new Error(`Missing URL config for SPA target: ${key}`);
  }

  const url = new URL(baseUrl);

  Object.entries(params ?? {}).forEach(([paramKey, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(paramKey, String(value));
    }
  });

  return url.toString();
}
